export default "__VITE_ASSET__b6a61b85__"